import { render } from "./Appearance.vue?vue&type=template&id=6afb0861&ts=true"
import script from "./Appearance.vue?vue&type=script&lang=ts"
export * from "./Appearance.vue?vue&type=script&lang=ts"

import "./Appearance.vue?vue&type=style&index=0&id=6afb0861&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__